import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          firstName: Yup.string(),
                                          lastName: Yup.string(),
                                          email: Yup.string()
                                                    .email('Invalid email')
                                                    .required('Required'),
                                          phone: Yup.string().nullable(),
                                          company: Yup.string().nullable(),
                                          position: Yup.string().nullable(),
                                          notes: Yup.string().nullable(),
                                      });
